export enum MediaPart {
  MainImage = 'mainImage',
  ShopImage = 'shopImage',
  BackCoverImage = 'backCoverImage',
  LogoImage = 'logoImage',
}

// moved from old GQL interface
export interface Media {
  url: string;
  id?: number;
  name?: string;
  subclipUrl?: string;
  thumbnails?: string[];
  contentType?: string;
  mediaType: MediaType;
  height?: number;
  width?: number;
  videoUrl?: string;
  mediaPart?: MediaPart;
  creation?: ActionInfoMedia;
  metadata?: string | null;
}

export enum MediaType {
  Image = 'image',
  Video = 'video',
  Youtube = 'youtube',
  Directshow = 'directshow',
  Livestream = 'livestream',
  Vimeo = 'vimeo',
}

// moved from old GQL interface
interface ActionInfoMedia {
  actionId: string;
  userId: string;
  displayName: string;
  timeStampUtc: string;
}
